import ajax from '@/utils/ajax'

/**
 * @module 我的账号
 */

 const BASE_URL = 'login/'

// 获取sendVerificationCode（解绑）
export const unbindSendCode = params => ajax.post('login/sendVerification', params)
// export const unbindSendCode = params => ajax.post(`${BASE_URL}sendVerificationCode`, params)

// 获取验证码 (换绑)
export const rebindSendCode = params => ajax.post('login/againBindSendVerifyCode', params)
// export const rebindSendCode = params => ajax.post(`${BASE_URL}sendVerificationCode`, params)

// 换绑手机号
export const changeBindPhone = params => ajax.post(`${BASE_URL}againBindMobile`, params)

// 解绑手机号
export const unbindPhone = params => ajax.post(`${BASE_URL}unbindMobile`, params)

// 更新密码
export const updatePassword = params => ajax.post(`${BASE_URL}updatePassword`, params)

// 更新个人信息
export const updateSelfAccount = params => ajax.post(`${BASE_URL}updateSelfAccount`, params)


